import React from 'react';
import Info from './components/Info';
import Form from './components/Form';
export default function LoginPage() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2">
        <Info />
        <Form />
    </div>
  );
};